import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../redux/store';
import PaymentModal from '../PaymentModal/PaymentModal';
import {
  fetchWalletSummary,
  clearSuccess,
  clearError
} from '../../redux/slices/walletSlice';
import BalanceWidget from '../BalanceWidget/BalanceWidget';
import FundingHistory from '../FundingHistory/FundingHistory';
import './AccountFunding.css';

const AccountFunding: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [activeTab, setActiveTab] = useState<'fund' | 'history'>('fund');

  // Initialize payment modal for funding
  useEffect(() => {
    if (activeTab === 'fund') {
      dispatch({ type: 'fidelityPayment/openModal' });
      dispatch({ type: 'fidelityPayment/setModalStep', payload: 'amount' });
    }
  }, [activeTab, dispatch]);

  const { error, success } = useSelector(
    (state: RootState) => state.wallet
  );

  useEffect(() => {
    dispatch(fetchWalletSummary());
  }, [dispatch]);

  // Auto-clear success
  useEffect(() => {
    if (!success) return;
    const timer = setTimeout(() => dispatch(clearSuccess()), 5000);
    return () => clearTimeout(timer);
  }, [success, dispatch]);

  // Auto-clear error
  useEffect(() => {
    if (!error) return;
    const timer = setTimeout(() => dispatch(clearError()), 5000);
    return () => clearTimeout(timer);
  }, [error, dispatch]);

  const handlePaymentSuccess = () => {
    dispatch(fetchWalletSummary());
  };

  const handlePaymentClose = () => {
    dispatch(fetchWalletSummary());
  };

  return (
    <div className="account-funding">
      {/* Balance */}
      <BalanceWidget
        onFundClick={() => setActiveTab('fund')}
        className="main-balance-widget"
      />

      {/* Fund Tab - Payment Modal */}
      {activeTab === 'fund' && (
        <div className="account-funding-content">
          <div className="funding-header">
            <h3>Fund Your Account</h3>
            <p>Add money to your wallet to make payments</p>
          </div>

          <PaymentModal
            mode="page"
            paymentType="funding"
            onSuccess={handlePaymentSuccess}
            onClose={handlePaymentClose}
          />
        </div>
      )}

      {/* History Tab */}
      {activeTab === 'history' && <FundingHistory />}


    </div>
  );
};

export default AccountFunding;
